export default {
      id: "arrow-usage",
      viewBox: "0 0 7 4",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#arrow",
      toString: function () {
        return this.url;
      }
    }